module.exports = __webpack_public_path__ + "static/media/homelogo.7ea4971c.png";